import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import fr from './locales/fr/translation.json';
import it from './locales/it/translation.json';
import cn from './locales/cn/translation.json';
import es from './locales/es/translation.json';
import se from './locales/se/translation.json';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en,
  fr,
  it,
  cn,
  es,
  se,
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
